// extracted by mini-css-extract-plugin
module.exports = {"BatchOperationsModal":"BatchOperationsModal___-kFUC"};